import axios, { AxiosRequestConfig } from 'axios';
import { ICollection } from '../interfaces/ICollection';
import IResponse from '../interfaces/IResponse';
import ApiHelper from './ApiHelper';
import { baseURL } from '../config';

const BASE_URL = `${baseURL}api/collections`;


interface IGetAllCollections extends IResponse {
    collections: ICollection[],
}

const getAllCollections = async (): Promise<IGetAllCollections> => {
    const url = BASE_URL;
    try {
        const res = await axios.get(url);

        const resoult = {
            ok: true,
            status: res.status,
            message: 'Pobrano kolekcje',
            collections: res.data.collections,
        }

        resoult.collections.sort((a: ICollection, b: ICollection) => a.name.localeCompare(b.name))
        // resoult.collections.reverse()

        return resoult;

    } catch (error) {
        let message = 'Nie udało się pobrać kolekcji';
        let status = 400;

        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 404) message = 'Nie znaleziono kolekcji'
            if (error.response.status === 403) message = 'Niedostępne'
        }

        return {
            message,
            status,
            ok: false,
            collections: [],
        }
    }

}

interface IAddCollection extends IResponse {
    collection: ICollection | null,
}

export interface IAddCollectionDto {
    name: string,
    producer: string,
    image: any,
}

const addCollection = async (collection: IAddCollectionDto): Promise<IAddCollection> => {
    const url = BASE_URL;

    const fd = new FormData();
    fd.append('name', collection.name);
    if (collection.producer !== undefined && collection.producer !== null) {
        fd.append('producer', collection.producer);
    }
    if (collection.image) {
        fd.append('image', collection.image);
    }

    const collectionConfig: AxiosRequestConfig = {
        headers: ApiHelper.createHeaderWithoutContentType(),
    }

    try {
        const response = await axios.post(url, fd, collectionConfig);

        const resoult = {
            collection: response.data.newCollection,
            message: 'Kolekcja dodana',
            ok: true,
            status: response.status,
        }

        return resoult
    } catch (error) {
        let message = 'Nie udało się dodać kolekcji'
        let status = 400;

        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 403) message = 'Nie można dodać kolekcji'
            if (error.response.status) status = error.response.status;
        }

        return {
            message,
            status,
            ok: false,
            collection: null,
        }
    }
}

interface IUpdateCollectionResponse extends IResponse {
    updatedCollection: ICollection | null,
}

const editCollection = async (collection: ICollection): Promise<IUpdateCollectionResponse> => {

    const url = `${BASE_URL}/${collection._id}`

    const collectionConfig: AxiosRequestConfig = {
        headers: ApiHelper.createHeaderForFiles(),
    }

    try {
        const response = await axios.put(url, collection, collectionConfig)

        const resoult = {
            updatedCollection: response.data.collection,
            message: 'Kolekcja została edytowana',
            ok: true,
            status: response.status
        }

        return resoult
    } catch (error) {

        let message = 'Nie udało się edytować kolekcji'
        let status = 400;

        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 404) message = 'Nie znaleziono kolekcji'
            if (error.response.status === 403) message = 'Niedostępne'
            if (error.response.status) status = error.response.status;
        }

        return {
            message,
            status,
            ok: false,
            updatedCollection: null,
        }
    }
}

interface IDeleteCollection extends IResponse { }

const deleteCollection = async (_id: string): Promise<IDeleteCollection> => {

    const url = `${BASE_URL}/${_id}`;
    const config: AxiosRequestConfig = {
        headers: ApiHelper.createHeader(),
    }

    try {
        const res = await axios.delete(url, config)

        const resoult = {
            ok: true,
            status: res.status,
            message: 'Kolekcja usunięta',
        }

        return resoult

    } catch (error) {

        let message = 'Nie usunięto kolekcji'
        let status = 400

        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 404) message = 'Nie znaleziono kolekcji'
            if (error.response.status === 403) message = 'Nie możesz tego zrobić'
            if (error.response.status) status = error.response.status
        }

        return {
            message,
            status,
            ok: false,
        }
    }
}


interface IGetSingleCollection extends IResponse {
    collection: ICollection | null,
}

const getSingleCollection = async (_id: string): Promise<IGetSingleCollection> => {

    const url = `${BASE_URL}/${_id}`;

    try {
        const res = await axios.get(url);

        const resoult = {
            ok: true,
            status: res.status,
            message: 'Pobrano kolekcję',
            collection: res.data.collection,
        }

        return resoult;

    } catch (error) {
        let message = 'Nie udało się pobrać kolekcji';
        let status = 400;

        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 404) message = 'Nie znaleziono kolekcji'
            if (error.response.status === 403) message = 'Niedostępne'
        }

        return {
            message,
            status,
            ok: false,
            collection: null,
        }
    }

}


interface IGetCollectionsByProducer extends IResponse {
    collections: ICollection[],
}

const getAllProducerCollections = async (producerId: string): Promise<IGetCollectionsByProducer> => {
    const url = `${BASE_URL}/producer/${producerId}`;

    try {
        const res = await axios.get(url);

        const resoult = {
            ok: true,
            status: res.status,
            message: 'Pobrano kolekcje',
            collections: res.data.collections,
        }

        resoult.collections.sort((a: ICollection, b: ICollection) => a.name.localeCompare(b.name))

        return resoult;

    } catch (error) {
        let message = 'Nie udało się pobrać kolekcji';
        let status = 400;

        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 404) message = 'Nie znaleziono kolekcji'
            if (error.response.status === 403) message = 'Niedostępne'
        }

        return {
            message,
            status,
            ok: false,
            collections: [],
        }
    }

}


const collectionsController = {
    getAllCollections,
    addCollection,
    editCollection,
    deleteCollection,
    getSingleCollection,
    getAllProducerCollections,
};

export default collectionsController;